"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptType = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
var PromptType;
(function (PromptType) {
    PromptType["OPEN_POSITION"] = "OPEN_POSITION";
    PromptType["GENERAL"] = "GENERAL";
    PromptType["OpenPosition"] = "OPEN_POSITION";
    PromptType["General"] = "GENERAL";
})(PromptType || (exports.PromptType = PromptType = {}));
